import { fetchJSON, one } from 'webmango-utils'
import { useValueState } from '../state'
import { Effect } from 'jumpstate'
import pLimit from 'p-limit'
import qs from 'querystring'

const DEFAULT = {
  webmango: {},
  filesystem: {},
/*  'filesystem sync': {},   Disabled, heavy on system and likely race condition between users */
  mdss: {},
  raijin: {},
  plexus: {}
}

const Status = useValueState('status', DEFAULT)

const IsLoading = useValueState('isLoadingServerStatus')
const Initialised = useValueState('initialised')

const pingServer = one(async () => {
  const startTime = Date.now()
  const result = await fetchJSON(`/api/ping`).catch(() => false)
  return {
    time: Date.now() - startTime,
    ok: !!result
  }
})

const wait = (timeout) => {
  return new Promise((resolve, reject) => setTimeout(resolve, timeout))
}

const fetchServiceStatus = one(async (service, timeout = 10000) => {
  const task = (service === 'webmango')
    ? pingServer()
    : fetchJSON(`/api/status/${service}?${qs.stringify({ timeout })}`)

  return Promise.race([
    task,
    wait(timeout * 2)
  ]).catch(() => false)
})

async function checkService (service) {
  try {
    IsLoading.enable(service)
    const status = await fetchServiceStatus(service)
    IsLoading.disable(service)
    Status.setState({
      [service]: status || {
        ok: false
      }
    })
  } catch (err) {
    IsLoading.disable(service)
    Status.setState({
      [service]: {
        ok: false
      }
    })
  }
}

export const checkStatus = Effect('checkStatus', one(async (_, getState) => {
  const { status } = getState()
  IsLoading.enable('checkStatus')
  const limit = pLimit(2)
  await Promise.all([Object.keys(status).map(service => limit(() => checkService(service)))])
  IsLoading.disable('checkStatus')
  Initialised.enable('checkStatus')
}))

export const resetStatuses = Effect('resetStatuses', () => {
  Status.replaceState(DEFAULT)
})



// WEBPACK FOOTER //
// ../webmango-core/effects/status.js